/**
 * Card shell — README §2. Bands persist across states: loading swaps the
 * rows band for skeletons, empty swaps it for the first-run block; header
 * and footer never disappear and the card never changes shape.
 */
import React from "react";
import Card from "../../theme/untitled/Card/Card";
import ConnectionRow from "./ConnectionRow";
import EmptyStateFirstRun from "./EmptyStateFirstRun";
import LoadingRows from "./LoadingRows";
import ApiError from "../../component/ApiError";
import Footer from "./Footer";
import styles from "../IntegrationsPage.module.scss";

const ConnectionsCard = ({
  integrations,
  isLoading,
  pageError,
  quota,
  disabledCount,
  savingUuid,
  onSelectProvider,
  rowProps,
}) => {
  const hasConnections = integrations.length > 0;

  const connectionRows = integrations.map((integration) => (
    <ConnectionRow
      key={integration.uuid}
      integration={integration}
      autoSyncSaving={savingUuid === integration.uuid}
      {...rowProps}
    />
  ));

  let cardBody;

  if (isLoading) {
    cardBody = <LoadingRows />;
  } else if (hasConnections) {
    cardBody = <div className={styles.rows}>{connectionRows}</div>;
  } else {
    cardBody = <EmptyStateFirstRun onSelectProvider={onSelectProvider} />;
  }

  return (
    <Card className={styles.card}>
      <Card.Header
        title="Connections"
        subtitle="Accounts syncing into this workspace."
        className={styles.cardHeader}
      />

      <ApiError
        error={pageError}
        defaultErrorMessage="Something went wrong. Please try again."
      />

      <Card.Body noPadding>{cardBody}</Card.Body>
      <Footer quota={quota} disabledCount={disabledCount} />
    </Card>
  );
};

export default ConnectionsCard;
